export default [
  'log_in@authentication',
  'validate_token@authentication',
  'get_profile@account',
  'user_update_profile@account',
  'update_admin_notification_preference@account',
  'user_update_password',
  'send_feedback@feedback',
];
